// Next occurrences (read-only) for onboarding ending — data from GET /api/user/onboarding/ending-page.

import React, { useMemo, useState } from 'react';

function safeBannerUrl(raw) {
  const s = raw != null ? String(raw).trim() : '';
  if (!s) return null;
  if (/^https:\/\//i.test(s)) return s;
  return null;
}

function EndingEventBanner({ url }) {
  const [broken, setBroken] = useState(false);
  const safe = safeBannerUrl(url);
  if (!safe || broken) {
    return (
      <span className="members-onboarding-ending-events__banner members-onboarding-ending-events__banner--placeholder" aria-hidden />
    );
  }
  return (
    <img
      className="members-onboarding-ending-events__banner"
      src={safe}
      alt=""
      onError={() => setBroken(true)}
    />
  );
}

function formatOccurrenceStart(iso, timeZone) {
  if (!iso) return '—';

  try {
    const d = new Date(iso);

    const parts = new Intl.DateTimeFormat('en-US', {
      ...(timeZone ? { timeZone } : {}),
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hour12: false,
    }).formatToParts(d);

    const byType = parts.reduce((acc, part) => {
      acc[part.type] = part.value;
      return acc;
    }, {});

    return `${byType.year}-${byType.month}-${byType.day} ${byType.hour}:${byType.minute}`;
  } catch (_) {
    return String(iso);
  }
}

const ENDING_UPCOMING_EVENTS_MAX = 4;

export default function MembersOnboardingEndingUpcomingEvents({ events, loading, timeZone }) {
  const list = useMemo(() => {
    if (!Array.isArray(events)) return [];
    return events.slice(0, ENDING_UPCOMING_EVENTS_MAX);
  }, [events]);

  return (
    <aside
      className="members-onboarding-ending-events"
      aria-label="Upcoming events"
      data-resource="members.onboarding.ending"
      data-action="read"
      data-description="Onboarding ending — upcoming events"
    >
      {loading ? (
        <p className="members-onboarding-ending-events__status">Loading events…</p>
      ) : null}
      {!loading && list.length === 0 ? (
        <p className="members-onboarding-ending-events__empty">No upcoming events scheduled.</p>
      ) : null}
      {!loading && list.length > 0 ? (
        <div className="members-onboarding-ending-events__stack">
          <div className="members-onboarding-ending-events__card members-onboarding-ending-events__card--heading">
            <p className="members-onboarding-ending-events__heading">Upcoming event</p>
          </div>
          <ul className="members-onboarding-ending-events__list">
            {list.map((row) => {
              const title = row.eventName != null ? String(row.eventName).trim() : '—';
              const when = formatOccurrenceStart(row.startTime, timeZone);
              return (
                <li
                  key={row.occurrenceId ?? `${row.eventId}-${row.startTime}`}
                  className="members-onboarding-ending-events__item"
                >
                  <article className="members-onboarding-ending-events__card members-onboarding-ending-events__card--event">
                    <div className="members-onboarding-ending-events__row">
                      <EndingEventBanner url={row.discordEventBanner} />
                      <div className="members-onboarding-ending-events__text">
                        <p className="members-onboarding-ending-events__name">{title}</p>
                        <p className="members-onboarding-ending-events__datetime">{when}</p>
                      </div>
                    </div>
                  </article>
                </li>
              );
            })}
          </ul>
        </div>
      ) : null}
    </aside>
  );
}
